import { UsersIcon, Building2Icon, DownloadIcon, ClockIcon, GraduationCapIcon, LayersIcon, SmartphoneIcon, type LucideIcon } from 'lucide-react';

export interface TrustStat {
  icon: LucideIcon;
  value: string;
  label: string;
}

export const trustStats: TrustStat[] = [
  { icon: UsersIcon, value: '+9K', label: 'Entrenadores activos' },
  { icon: Building2Icon, value: 'Más de 1.000', label: 'Clubes y Colegios' },
  { icon: DownloadIcon, value: '+150.000', label: 'Descargas del sistema' },
  { icon: ClockIcon, value: '+4 horas', label: 'Ahorradas / semana' }
];

export interface TrustBadge {
  icon: LucideIcon;
  title: string;
  text: string;
}

export const trustBadges: TrustBadge[] = [
  {
    icon: GraduationCapIcon,
    title: 'Voleibol Base Real',
    text: 'Diseñado por entrenadores con años de experiencia en el voleibol base español. Para la realidad de la pista pequeña, los 12 chavales y el padre que grita desde la gradería.'
  },
  {
    icon: LayersIcon,
    title: 'Todas las Categorías',
    text: 'Desde Alevín (8-10 años) hasta Juvenil y Amateur. Con adaptaciones específicas para categoría por edad y nivel de juego.'
  },
  {
    icon: SmartphoneIcon,
    title: 'Multidispositivo',
    text: 'Tablet, móvil, PC o para imprimir — consúltalo desde el banquillo sin que nadie lo note. Acceso desde cualquier lugar.'
  }
];
